import React, { useState, useCallback } from 'react';
import { Box } from '@mui/material';
import { GridComponent, ColumnsDirective, ColumnDirective, Sort, Page, Selection, Inject } from '@syncfusion/ej2-react-grids';
import { useAppSelector } from '../../../../../app/store';
import { WriteoffNoteView } from '../../../../../services/WriteoffService/types/writeoffTypes';
import ViewNoteDialog from '../../dialogs/ViewNoteDialog';
import { noteDateTemplate, noteTextTemplate } from './templates';

const NotesGrid: React.FC = () => {
  const { currentWriteoff } = useAppSelector(state => state.writeoff);
  const notes = currentWriteoff?.notes || [];

  // Sort notes with newest first
  const sortedNotes = [...notes].sort(
    (a, b) => new Date(b.addDate || '').getTime() - new Date(a.addDate || '').getTime()
  );

  const [selectedNote, setSelectedNote] = useState<WriteoffNoteView | null>(null);
  const [showViewDialog, setShowViewDialog] = useState(false);

  const onRowSelected = useCallback((args: any) => {
    const selectedItem = args.data as WriteoffNoteView;
    setSelectedNote(selectedItem);
    setShowViewDialog(true);
  }, []);

  const handleCloseViewDialog = useCallback(() => {
    setShowViewDialog(false);
    setSelectedNote(null);
  }, []);

  return (
    <Box sx={{ height: '400px', width: '100%', maxWidth: '1200px' }}>
      <GridComponent
        dataSource={sortedNotes}
        allowSorting={true}
        allowPaging={true}
        pageSettings={{ pageSize: 10 }}
        selectionSettings={{ mode: 'Row', type: 'Single' }}
        rowSelected={onRowSelected}
        height="100%"
      >
        <ColumnsDirective>
          <ColumnDirective
            field="addDate"
            headerText="Date Added"
            width="180"
            template={noteDateTemplate}
          />
          <ColumnDirective field="addedBy" headerText="Added By" width="150" />
          <ColumnDirective field="text" headerText="Note Text" template={noteTextTemplate} />
        </ColumnsDirective>
        <Inject services={[Sort, Page, Selection]} />
      </GridComponent>

      {showViewDialog && selectedNote && (
        <ViewNoteDialog open={showViewDialog} note={selectedNote} onClose={handleCloseViewDialog} />
      )}
    </Box>
  );
};

export default NotesGrid;
